<template>
  <!-- <div class="maximum-box"> -->
  <el-container>
    <el-header>
      <div class="info-box">
        <div class="describe-text"><span>跟踪号：</span>{{ ticketCode }}</div>
      </div>
    </el-header>
    <el-main>
      <div class="subject-box">
        <el-upload
          ref="upload"
          :data="data"
          multiple
          :before-upload="beforeupload"
          :action="uploaddUrl"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :on-success="uploadingSuccess"
          :headers="{ staffId: staffId, staffName: staffName }"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过9张图片
          </div>
        </el-upload>
      </div></el-main
    >
    <el-footer>
      <div class="btn">
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="handluCloses">取 消</el-button> -->
          <el-button
            class="submitQCImg"
            type="primary"
            @click="confirmPutinStorage()"
            >提交图片</el-button
          >
        </span>
      </div></el-footer
    >
  </el-container>

  <!-- </div> -->
</template>

<script>
// import axios from 'axios'
// import { purchaseInStockIn, upload } from "@/api/PutInStorageOrder";
import {
  loading,
  loadingClose,
  message,
  dateFormat,
  confirmMsg,
} from "@/utils/common";
export default {
  data() {
    return {
      //uploaddUrl: `http://test.wms.java.api.nantang-tech.com/multipartFile/upload/`,
      uploaddUrl: `http://wms.java.nantang-tech.com/multipartFile/upload/`,
      dialogImageUrl: "",
      fileList: [],
      skuName: "",
      ticketCode: "",
      count: "",
      sku: "",
      ean: "",
      skuImage: "",
      staffId: "",
      staffName: "",
      data: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 获取信息
    getInfo() {
      this.skuName = decodeURIComponent(this.getParmeter("skuName"));
      console.log(this.skuName, "skuName");
      this.ticketCode = this.getParmeter("ticketCode");
      this.count = this.getParmeter("count");
      this.sku = this.getParmeter("sku");
      this.ean = this.getParmeter("ean");
      this.skuImage = this.getParmeter("skuImage");
      this.staffId = this.getParmeter("id");
      this.staffName = this.getParmeter("userName");
      // this.$store.state.id = this.staffId
      // this.$store.state.id = this.staffName
      sessionStorage.setItem("staff-id", this.staffId);
      sessionStorage.setItem("name", this.staffName);
      // console.log(this.staffId,this.staffName,'??????????');
    },
    // 解析url
    getParmeter(variable) {
      if (window.location.href.split("?")[1].length) {
        let query = window.location.href.split("?")[1]; // 这里query的结果是：   promotion_code=ZB06AKXFSR&sku=100
        let vars = query.split("&"); // 这里vars的结果是：   ["promotion_code=ZB06AKXFSR", "sku=100"]
        for (let i = 0; i < vars.length; i++) {
          //然后循环
          let pair = vars[i].split("="); //  循环第一次结果pair ["promotion_code", "ZB06AKXFSR"]  循环第二次结果pair ["sku", "100"]
          if (pair[0] === variable) {
            // 做判断 如果参数名和我们的实参一样
            console.log(pair, "pair");
            return pair[1]; // 就返回对应的值
          }
        }
        return "";
      }
    },

    // 提交质检图片
    async confirmPutinStorage() {
      // let data = {
      //   key: this.ticketCode,
      //   file: this.fileList
      // }
      // console.log(data,'data');
      // await upload(data);
      // console.log(this.fileList,'this.fileList');
      // this.data.key = this.ticketCode;
      // this.$refs.upload.submit();
      this.$router.push("/finish");
    },
    // 文件上传之前
    beforeupload(file) {
      // console.log(file,'file'); //  10,485,760 相当月10兆
      if (file.size > 10485760) {
        console.log("文件过大");
        message("warning", "文件过大,请重新上传少于10M文件！");
        return false;
      }
      this.data.key = this.ticketCode;
    },
    //   上传成功
    uploadingSuccess(response, file, fileList) {
      // console.log(response, file, fileList, 'response, file, fileList');
      const { code, data } = response;
      if (code === 0) {
        data.map((item) => {
          this.fileList.push(item.url);
        });
        message("success", "上传成功");
      }
      // console.log(this.fileList, 'this.fileList');
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      console.log(file, fileList);
    },
  },
  mounted() {
    // console.log(process.env,'process.env');
    // console.log(process.env.VUE_APP_API,'process.env.VUE_APP_API');
    // console.log(window.location.href.split('?'),'window.location.href.split("?"")');
  },
};
</script>

<style lang="less" scoped>
.img-box {
  width: 100px;
  height: 200px;
  float: left;
  margin-right: 20px;
  // background-color: red;
  img {
    width: 100px;
    height: 100px;
  }
}
.el-header {
  height: 40px !important;
  //  background-color: red;
}
.describe-text {
  line-height: 29px;
}

.info-box {
  height: 20%;
  // background: red;
  // border: 1px solid rgb(223, 217, 217);
}
.subject-box {
  height: 40%;
  // background: yellow;
  // border: 1px solid red;
}
.btn {
  text-align: center;
  .el-button {
    width: 100%;
    font-size: 20px;
  }
}
</style>
